import * as React from 'react';
import { SingleValueComponent } from 'ui/common/types';
import { Label, CheckSymbol, InfoText } from 'ui/common';
import { InputControlContext } from 'ui/common/input-control-context/input-control-context';
import styles from './checkbox.scss';
import { v1 as uuid } from 'uuid';
import { keyCodeTypes } from 'ui/common/key-code-types';

/**
 * Creates Checkbox component.
 *
 */

export interface CheckboxProps extends SingleValueComponent<number> {
  /**
   * translation text if the value is selected
   */
  textCheckedValue?: string;
  /**
   * translation text if the value is not selected
   */
  textUncheckedValue?: string;
}

export class Checkbox extends React.Component<CheckboxProps, any> {

  constructor(props: SingleValueComponent<number>) {
    super(props);
    this.state = {
      componentUuid: uuid()
    };
  }

  private onChange = () => {
    this.props.onChange && this.props.onChange(Number(!this.props.value));
  };

  private onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code === keyCodeTypes.Enter) {
      this.onChange();
    }
  };

  public render() {
    const {className, label, value, componentId, validation, readOnly, info, infoLong} = this.props;
    const {componentUuid} = this.state;

    return (
      <InputControlContext
        componentId={componentId}
        className={`${className} ${styles.inputControl}`}
        validation={validation}
        infoLong={infoLong}>
        <div className={styles.wrapper}>
        {label && label.required && <span className={`asterisk-required ${styles.asterisk}`}>* </span>} 
        <input id={`checkbox-${componentId}-${componentUuid}`}
               type="checkbox"
               checked={!!value}
               disabled={readOnly}
               onChange={this.onChange}
               onKeyDown={this.onKeyDown}
               className="visuallyhidden form-check-input"/>
          <Label htmlFor={`checkbox-${componentId}-${componentUuid}`}
                 classNames="form-check-label"
                 label={label}
                 selectSymbol={<CheckSymbol/>}/>
            <InfoText {...info} />
        </div>
      </InputControlContext>
    );
  }
}
